import React from 'react';
import { Cake, Heart, Music, Smartphone, Sparkles, Star } from 'lucide-react';

export function DigitalInvitesHeroMockups({ mock }) {
  return (
    <div className="relative mx-auto w-full max-w-xl lg:max-w-none lg:mx-0 min-h-[400px] sm:min-h-[460px] lg:min-h-[520px] overflow-x-hidden">
      <div
        className="absolute inset-0 rounded-[2rem] bg-gradient-to-br from-rose-500/[0.08] via-transparent to-violet-500/[0.07] blur-2xl pointer-events-none animate-pulse"
        style={{ animationDuration: '4s' }}
        aria-hidden
      />

      {/* Casamento */}
      <div className="absolute left-0 top-6 sm:top-10 w-[min(100%,250px)] rounded-2xl border border-white/[0.12] bg-slate-950/85 backdrop-blur-xl shadow-[0_24px_80px_-24px_rgba(244,114,182,0.3)] p-4 z-20 rotate-[-2deg] hover:rotate-0 transition-transform duration-500">
        <div className="flex items-center gap-2 mb-3">
          <Heart className="w-4 h-4 text-rose-400" aria-hidden />
          <span className="text-[10px] font-semibold uppercase tracking-wider text-white/45">{mock.weddingLabel}</span>
        </div>
        <div className="rounded-xl border border-rose-500/20 bg-gradient-to-br from-rose-950/50 to-slate-900/80 p-4 aspect-[4/5] flex flex-col items-center justify-center">
          <Heart className="w-8 h-8 text-rose-400/80 mb-2" aria-hidden />
          <div className="h-2 w-20 rounded-full bg-white/20 mb-1.5" />
          <div className="h-1.5 w-14 rounded-full bg-white/10" />
          <Sparkles className="w-4 h-4 text-amber-300/70 mt-3 animate-pulse" aria-hidden />
        </div>
      </div>

      {/* Aniversário */}
      <div className="absolute right-0 top-0 w-[min(100%,220px)] rounded-2xl border border-white/[0.12] bg-slate-950/80 backdrop-blur-xl shadow-[0_20px_60px_-20px_rgba(251,191,36,0.25)] p-3 z-10 rotate-[2deg] sm:right-2 lg:right-6 hover:rotate-0 transition-transform duration-500">
        <div className="rounded-xl border border-amber-500/20 bg-gradient-to-br from-amber-500/10 to-slate-900/80 p-3">
          <div className="flex items-center gap-2 mb-2">
            <Cake className="w-4 h-4 text-amber-400" aria-hidden />
            <span className="text-[10px] font-semibold text-white/70">{mock.birthdayLabel}</span>
          </div>
          <div className="flex gap-1 justify-center mb-2">
            {[Star, Star, Star].map((Icon, i) => (
              <Icon key={i} className="w-3 h-3 text-amber-400/80" aria-hidden />
            ))}
          </div>
          <div className="h-16 rounded-lg bg-amber-500/10 border border-amber-500/15 flex items-end justify-center pb-1">
            <Cake className="w-6 h-6 text-amber-300/90" aria-hidden />
          </div>
        </div>
      </div>

      {/* Infantil animado */}
      <div className="absolute left-10 sm:left-16 bottom-32 sm:bottom-36 w-[140px] rounded-xl border border-violet-500/25 bg-violet-950/50 backdrop-blur-md px-3 py-2.5 z-30 shadow-lg rotate-[3deg] hover:rotate-0 transition-transform duration-500">
        <div className="flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-violet-400 shrink-0 animate-pulse" aria-hidden />
          <div>
            <p className="text-[9px] font-bold text-violet-200/95">{mock.kidsLabel}</p>
            <p className="text-[10px] text-violet-300/70">{mock.animatedLabel}</p>
          </div>
        </div>
      </div>

      {/* Mobile preview */}
      <div className="absolute right-6 sm:right-12 bottom-24 sm:bottom-28 w-[min(100%,130px)] rounded-2xl border border-white/[0.12] bg-slate-950/90 backdrop-blur-md p-2 z-40 shadow-lg">
        <div className="rounded-xl border border-white/10 bg-slate-900 overflow-hidden">
          <div className="h-1.5 bg-slate-800 flex justify-center pt-0.5">
            <div className="w-8 h-0.5 rounded-full bg-white/15" />
          </div>
          <div className="aspect-[9/14] bg-gradient-to-b from-rose-500/20 via-violet-500/15 to-slate-950 p-2 flex flex-col items-center justify-center">
            <Smartphone className="w-3 h-3 text-white/30 mb-1 absolute top-3 right-2" aria-hidden />
            <Heart className="w-4 h-4 text-rose-400/70 mb-1" aria-hidden />
            <div className="h-1 w-10 rounded-full bg-white/15" />
          </div>
        </div>
      </div>

      {/* Convite animado + música */}
      <div className="absolute left-1/2 -translate-x-1/2 bottom-4 sm:bottom-8 w-[min(100%,290px)] rounded-2xl border border-violet-500/20 bg-gradient-to-br from-slate-950/95 to-slate-900/85 backdrop-blur-xl shadow-[0_28px_90px_-28px_rgba(139,92,246,0.25)] p-4 z-25">
        <div className="flex items-center justify-between gap-2 mb-3">
          <span className="text-[10px] font-semibold uppercase tracking-wider text-violet-200/80">{mock.premiumLabel}</span>
          <Music className="w-3.5 h-3.5 text-violet-400" aria-hidden />
        </div>
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-xl bg-violet-500/20 border border-violet-500/25 flex items-center justify-center shrink-0">
            <Sparkles className="w-5 h-5 text-violet-300 animate-pulse" aria-hidden />
          </div>
          <div className="flex-1 space-y-1.5">
            <div className="h-2 w-full rounded-full bg-white/15" />
            <div className="flex gap-0.5 items-end h-4">
              {[3, 5, 4, 6, 3, 5].map((h, i) => (
                <div key={i} className="w-1 rounded-full bg-violet-400/50" style={{ height: `${h * 3}px` }} />
              ))}
            </div>
          </div>
        </div>
        <p className="text-[9px] text-violet-300/70 mt-3 text-center">{mock.interactiveLabel}</p>
      </div>
    </div>
  );
}
